import { API } from '../../../config'

export const updatePersonalInfo = (value, successCB, failedCB) => async dispatch => {
  API.POST('/profile/personal', value).then((response) => {
    return successCB && successCB(response)
  })
  .catch((err) => {
    return failedCB && failedCB(err.error || err.message)
  })
}